import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import NotificationDetail from './NotificationDetail';
import NotificationList from './NotificationList';

export default function NotificationReplay() {
  useDocumentTitle('Notification Replay - Admin');

  const { path } = useRouteMatch();

  return (
    <Page>
      <Header />
      <Switch>
        <Route exact path={path}>
          <NotificationList />
        </Route>
        <Route path={`${path}/:notificationId`}>
          <NotificationDetail />
        </Route>
      </Switch>
    </Page>
  );
}
